import { render, staticRenderFns } from "./TotalViews.vue?vue&type=template&id=e1cb9924&scoped=true"
import script from "./TotalViews.vue?vue&type=script&lang=js"
export * from "./TotalViews.vue?vue&type=script&lang=js"
import style0 from "./TotalViews.vue?vue&type=style&index=0&id=e1cb9924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cb9924",
  null
  
)

export default component.exports